import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ACustomStepWizard } from 'app/shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { InfoDialogComponent } from 'app/shared/components/info-dialog/info-dialog.component';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'biz-import-step40',
  templateUrl: './import-step40.component.html',
  styleUrls: ['./import-step40.component.scss']
})
export class ImportStep40Component implements OnInit {
  @Input() data;
  @Output() isValidEmit = new EventEmitter<boolean>();
  @ViewChild('infoDialog', { static: false }) infoDialog: InfoDialogComponent;
  @ViewChild('fileUpload', { static: false }) fileUploader: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  public isValid() {
  }
}
